<!-- @format -->

<template>
	<el-input-number v-model="value" :max="options.max" :min="options.min" />
</template>

<script setup lang="ts">
	interface Props {
		modelValue: number | string | null;
		options: any;
	}

	const props = withDefaults(defineProps<Props>(), {
		modelValue: null,
	});

	const emit = defineEmits(['update:modelValue']);

	const value = computed({
		get() {
			return Number(props.modelValue) || undefined;
		},
		set(value) {
			emit('update:modelValue', value);
		},
	});
</script>

<style scoped></style>
